const errorMessages = {
  errorMessage: "This field is required",
  errorEmail: "Please enter a valid email",
};

export default errorMessages;
